import { FAST_INTERVAL, CURRENT_CHAIN_ID, SLOW_INTERVAL } from 'constants/index'
import { DependencyList, EffectCallback, useEffect } from 'react'
import useSWR from 'swr'

type BlockEffectCallback = (blockNumber: number) => ReturnType<EffectCallback>

const EMPTY_ARRAY: any[] = []

export function useFastRefreshEffect(effect: BlockEffectCallback, deps?: DependencyList) {
  // TODO: Handle multiple networks
  const chainId = CURRENT_CHAIN_ID
  const { data = 0 } = useSWR(chainId && [FAST_INTERVAL, 'blockNumber', chainId])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect.bind(null, data), [data, ...(deps || EMPTY_ARRAY)])
}

export function useSlowRefreshEffect(effect: BlockEffectCallback, deps?: DependencyList) {
  // TODO: Handle multiple networks
  const chainId = CURRENT_CHAIN_ID
  const { data = 0 } = useSWR(chainId && [SLOW_INTERVAL, 'blockNumber', chainId])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect.bind(null, data), [data, ...(deps || EMPTY_ARRAY)])
}
